const createQuery = () => `
... on AdvertWidget {
  slotName
  size
  suffix
  alignment
  background
  keyValueTargeting {
    key
    value
  }
}
`
export default createQuery
